<span class="material-icons" [ngClass]="[getClassName(), getSize()]" [ngStyle]="getColor()">{{getName()}}</span>